import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    Validators
} from '@angular/forms';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs/Rx';

import { SettingsBaseService } from './settings-base.service';
import {AutoUnsubscribe} from "../../../fw/decoractors/AutoUnsubscribe";
import {ValidationMessageComponent} from "../../shared/validation-message.component";
import {FormService} from "../../../fw/services/form.service";
import {SharedService} from "../../shared/shared.service";
import {SharedValidators} from "../../shared/shared-validators";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";

@Component({
    selector: 'change-user-password',
    styles: [require('./change-user-password.component.css')],
    template: require('./change-user-password.component.html')
})
@AutoUnsubscribe()
export class ChangeUserPasswordComponent implements OnInit {
    @Input()
    dialog: DialogRef;
    @ViewChild('validationMessage', {static: false})
    validationMessage: ValidationMessageComponent;
    form: FormGroup;

    constructor(
        private fb: FormBuilder,
        private fs: FormService,
        private ds: SettingsBaseService,
        private ss: SharedService
    ) {}

    ngOnInit() {
        this.form = this.fb.group({
            oldPassword: [
                null,
                [SharedValidators.customRequired],
                [
                    AsyncValidatorWrapper.debounce(
                        this.validateCurrentPassword.bind(this)
                    )
                ]
            ],
            newPassword: [null, [SharedValidators.customRequired]],
            newPasswordRepeat: [
                null,
                Validators.compose([
                    SharedValidators.customRequired,
                    this.validateNewPasswordRepeat.bind(this)
                ])
            ]
        });

        this.form.valueChanges
            .debounceTime(500)
            .subscribe(() => this.validationMessage.getFormValidationErrors());
    }

    validateCurrentPassword(control: AbstractControl) {
        return Observable.create(observer => {
            if (control.dirty && control.value != null) {
                this.ds
                    .checkCurrentUserPassword(control.value)
                    .subscribe((response: boolean) => {
                        observer.next(response ? null : { currentPasswordNoMatch: true });
                        observer.complete();
                        if (this.validationMessage) this.validationMessage.getFormValidationErrors();
                    });
            } else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    validateNewPasswordRepeat(control: AbstractControl) {
        if (control.dirty) {
            if (control.value != this.form.value.newPassword)
                return { newPasswordRepeatMismatch: true };
            else return null;
        }

        return null;
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            this.ds
                .changeUserPassword({
                    oldPassword: this.form.value.oldPassword,
                    newPassword: this.form.value.newPassword
                })
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    } else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-base/change-user-password.component.ts